/* Tysk katalog for locale-supplier-country-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  "purchaseDocs.removeAll": "Alle entfernen",
  "purchaseDocs.removeOne": "{name} vom Einkauf entfernen",
  "purchaseDocs.duplicateTitle": "Mögliche Doppelbuchung",
  "purchaseDocs.duplicateHelp": "Prüfen Sie frühere Einkäufe. Sie können trotzdem buchen.",
  "purchaseDocs.sameAttachment": "Dieselbe Datei wurde mehrfach angehängt.",
  "purchaseDocs.sameFile": "Dieselbe Datei wird bei Beleg {number} · {date} verwendet.",
  "purchaseDocs.sameDetails": "Beleg {number} · {date} hat dasselbe Datum und denselben Betrag.",
  "purchaseFlow.listTitle": "Einkaufsliste",
  "purchaseFlow.purchaseCount": "Einkäufe",
  "purchaseFlow.netPurchases": "Nettoeinkäufe",
  "purchaseFlow.netPurchasesHelp": "Ohne MwSt., nach Gutschriften",
  "purchaseFlow.includingVat": "Inkl. MwSt.",
  "purchaseFlow.credited": "Gutgeschrieben",
  "purchaseFlow.creditable": "Noch gutschreibbar",
  "purchaseFlow.creditAllocationHelp": "Wählen Sie die Rechnung vor der Buchung zur automatischen Verrechnung. Der über den offenen Saldo hinausgehende Betrag bleibt Lieferantenguthaben.",
  "err.supplierCredit.invalidAmount": "Der Gutschriftbetrag muss positiv sein und darf den noch nicht gutgeschriebenen Betrag nicht überschreiten. Zahlungen reduzieren diese Grenze nicht.",
  "err.purchase.duplicateSupplierDocument": "Diese Belegnummer ist für den Lieferanten bereits registriert. Öffnen Sie die vorhandene Rechnung oder Gutschrift.",
  'purchaseFlow.creditNote': 'Gutschrift',
  "purchaseFlow.negativeWarning": "Ein negativer Rechnungsbetrag ist ungewöhnlich, außer bei einer Gutschrift.",
  "purchaseFlow.creditOriginal": "Gutgeschriebene Rechnung (optional)",
  "purchaseFlow.standaloneCredit": "Ohne Zuordnung – Guthaben beim Lieferanten",
  "purchaseFlow.creditLinesRequired": "Neue negative Positionen verwenden und direkt buchen. Entwürfe und Bearbeitung werden hier nicht unterstützt.",
  "err.supplierCredit.unsupportedLines": "Normale Einkaufspositionen verwenden. Lager, Anlagen und besondere Umsatzsteuer erfordern eine gesonderte Korrektur.",
  'registry.toggleSupplierHelp': 'Schlägt norwegische Unternehmen vor, während du Lieferantennamen oder Organisationsnummer eingibst.',
  'sup.foreignToggle': 'Ausländischer Lieferant',
  'sup.foreignToggleHelp': 'Aktiviere die Option für Lieferanten, die in einem anderen Land als dein Unternehmen registriert sind.',
  'sup.countryCode': 'Ländercode',
  'sup.countryCodePh': 'z. B. SE oder US',
  'sup.countryRequired': 'Gib für den ausländischen Lieferanten einen zweistelligen Ländercode an.',
  'sup.registrationNumber': 'Registrierungsnummer',
  'sup.registrationNumberPh': 'Ausländische Registrierungsnummer des Lieferanten',
  'sup.vatNumber': 'USt-IdNr./MwSt.-Nummer',
  'sup.vatNumberPh': 'z. B. SE123456789001',
});
